export function maskString(input, maskingEnable = false, visibleStart = 0, visibleEnd = 0, maskChar = '*', maskAll = false) {
	if (!maskingEnable) return input;

    // Convert input to string
    const stringInput = String(input);
    const length = stringInput.length;
    
    if (maskAll) {
        return maskChar.repeat(length);
    }
    if (visibleStart + visibleEnd === 0)
        return stringInput;
    if (visibleStart + visibleEnd >= length) {
        return stringInput; // No masking needed
    }
    const maskedPart = maskChar.repeat(length - visibleStart - visibleEnd).slice(0,7);
    return stringInput.slice(0, visibleStart) + maskedPart + stringInput.slice(length - visibleEnd);
}